import { render, staticRenderFns } from "./UrgencyStartForm.vue?vue&type=template&id=5a5eccec&scoped=true&"
import script from "./UrgencyStartForm.vue?vue&type=script&lang=js&"
export * from "./UrgencyStartForm.vue?vue&type=script&lang=js&"
import style0 from "./UrgencyStartForm.vue?vue&type=style&index=0&id=5a5eccec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5eccec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
